import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { LangContext } from "../LangContext.jsx";

class ProviderInvitationInformationCard extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            documents:[],
            invitation: {
                name: "",
                email:"",
                identity:"",
                rfc:"",
                internal_id:""
            }
        }; 
    }
    getInvitation = ()=>{
        axios.get('/api/invitations/'+this.props.invitation_id).then(res=>{
            this.setState({invitation:res.data})
            
        })
    }
    componentDidMount() {
        this.getInvitation()
    }
    
    render() {
        const { lang } = this.context; 
        return ( <div className="d-flex align-items-center col-5">
        <div className="symbol symbol-40 mr-5">
            <div className="symbol-label bg-primary text-white font-weight-bolder">
                {this.state.invitation.name[0] }
            </div>
            
        </div>
        <h5 className="text-dark font-weight-bold my-1 mr-5">
            {this.state.invitation.name} &nbsp;<span className="text-muted font-weight-bold font-size-sm">{ this.state.invitation.email  }</span>
            <br></br>
            <div className="mt-2 font-size-sm">
                <span className="text-muted font-weight-bold">{lang.get('messages.expediente_invitado')}: </span>
                <span className="text-success mr-10">{ this.state.invitation.dossier?.title }</span>
            </div>
            <div className="mt-2 font-size-sm">

            <span className="text-muted font-weight-bold"> {this.state.invitation.identity}: </span>
            <span className="text-success">{ this.state.invitation.rfc }</span>
            <span className="text-muted">
                    &nbsp; 
                    | &nbsp;
                    {( this.state.invitation.internal_id != null) && 
                    <>
                        No. interno: {  this.state.invitation.internal_id } {' | '}
                    </>
                    } 
                    { this.state.invitation.dossier?.target.name }
                    &nbsp;
                    ({ this.state.invitation.dossier?.type.title })
                </span>
            </div>
            </h5>

    </div>);
    }
}

export default ProviderInvitationInformationCard;

if (document.getElementById('ProviderInvitationInformationCard')) {
    ReactDOM.render(<ProviderInvitationInformationCard />, document.getElementById('ProviderInvitationInformationCard'));
}
